import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";
// import { Link } from 'react-router-dom';
// import Icon from 'components/Icon';
import { vars } from "./settings";

const StyledList = styled.section`
  ${(props) => css`
    /* margin: 40px 20px 20px; */
    display: grid;
    grid-gap: var(--s-medium);
    grid-template-columns: repeat(1, 1fr);
    ${props.justify && `justify-items: ${props.justify}`};
    ${props.align && `align-items: ${props.align}`};
    margin-bottom: var(--s-large);
    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: 800px) {
      grid-template-columns: repeat(${(props) => props.columns}, 1fr);
    }

    ${(props) =>
      props.s &&
      css`
        grid-template-columns: repeat(${props.s}, 1fr);
      `}

    ${(props) =>
      props.m &&
      css`
        @media (min-width: ${vars.mq.md}) {
          grid-template-columns: repeat(${props.m}, 1fr);
        }
      `}

    ${(props) =>
      props.l &&
      css`
        @media (min-width: ${vars.mq.lg}) {
          grid-template-columns: repeat(${props.l}, 1fr);
        }
      `}

    ${(props) =>
      props.xl &&
      css`
        @media (min-width: ${vars.mq.xl}) {
          grid-template-columns: repeat(${props.xl}, 1fr);
        }
      `}
  `}
`;

function LayoutList(props) {
  const { children, ...rest } = props;
  return <StyledList {...rest}>{children}</StyledList>;
}

LayoutList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  justify: PropTypes.string,
  align: PropTypes.string,
  columns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  s: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  l: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

LayoutList.defaultProps = {
  children: "",
  justify: "stretch",
  align: undefined,
  columns: 1,
  // responsive columns:
  s: undefined,
  m: undefined,
  l: undefined,
};

LayoutList.displayName = "LayoutList";
export default LayoutList;
